import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../services/data.service';
import { AuthService } from '../../services/auth.service';
import { JossoService } from '../../services/josso.service';
import { User } from '../../models/user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent extends AppComponentGenericComponent implements OnInit {
	@Output() menuState = new EventEmitter();
	userTooltip: string = "";
	private comuneId: any = -1;
	comuneNome: string = "comune";
	comuneSync: Subscription;
	ruoloUtente: string = "";
	backCommandEnabled: boolean = false;

	comuni: any[] = [];
	comuniDisponibiliSync: Subscription;
	notifiche: any[] = [];
	notificheSync: Subscription;

	conversazioni: any = {}
	messaggi: any[] = [];
	altreNotifiche: any[] = [];

	conversationsUnread: any = ""; // "99+";
	notificationsUnread: any = ""; // "99+";
	conversationsOpen: boolean = false;
	notificheOpen: boolean = false;

	constructor(protected dataService: DataService, private authService:AuthService, private jossoService: JossoService) {
		super(dataService, 'header');
	}

	ngOnInit() {
		this.comuniDisponibiliSync = this.dataService.getComuniService().comuniDisponibili$.subscribe(
			comuniDisponibili => {
				this.comuni = [];
				if(comuniDisponibili.length){
					for(let comune of comuniDisponibili){
						if(comune.attivo == 1){
							this.comuni.push(comune);
						}
					}
					console.log('CMP|HEADER - comuni disponibili', this.comuni);
				}
			});
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			(comune) => {
				if(comune){
					this.comuneId = comune.id;
					this.comuneNome = comune.nome_lungo;
					this.getLivelloUtente();
				}
		});
		this.notificheSync = this.dataService.notificheSistema$.subscribe(
			notificheSistema => {
				if(notificheSistema.length){
					let notifichePreRev = _.cloneDeep(notificheSistema)
					this.conversazioni = {}
					this.notifiche = notifichePreRev.reverse();
					this.conversationsUnread = 0;
					this.notificationsUnread = 0;
					let listaMessaggi = this.notifiche.filter(
						notifica => {
							if (notifica.tipo == "conversazioni" && notifica.letto == 0) {
								this.conversationsUnread += 1
							}
							return notifica.tipo == "conversazioni"
						}
					)
					this.altreNotifiche = this.notifiche.filter(
						notifica => {
							if (notifica.tipo != "conversazioni" && notifica.letto == 0) {
								this.notificationsUnread += 1
							}
							return notifica.tipo != "conversazioni"
						}
					)
					for (let messaggio of listaMessaggi) {
						let conversazioneId = messaggio.item_id
						if (!this.conversazioni[conversazioneId]) {
							this.conversazioni[conversazioneId] = {
								messaggi : [],
								unread : 0
							}
						}
						this.conversazioni[conversazioneId].messaggi.push(messaggio)
						if (messaggio.letto == 0) {
							this.conversazioni[conversazioneId].unread += 1
						}
					}
					console.log('CONVERSAZIONI RAGGRUPPATE',this.conversazioni);
					for (let key of Object.keys(this.conversazioni)) {
						let messaggio = this.conversazioni[key].messaggi[0]
						this.messaggi.push(messaggio)
					}
					this.messaggi = _.orderBy(this.messaggi,['data'],['desc'])
					this.conversationsUnread = String(this.conversationsUnread);
					this.notificationsUnread = String(this.notificationsUnread);
					console.log("CMP|HEADER - notifiche", this.notifiche, this.messaggi, this.altreNotifiche)
				}
			});
	}

	formatDate(date){
		let d = new Date(date);
		let day = d.getDate();
		let month = d.getMonth()+1;
		let year = d.getFullYear();
		let minutes = d.getMinutes()
		let hours = d.getHours()
		return day+"/"+month+"/"+year+" "+hours+":"+minutes;
	}

	closeConversations(){
		this.conversationsOpen = false;
	}

	openConversations(){
		this.notificheOpen = false;
		if(this.conversationsOpen){
			this.conversationsOpen = false;
		}
		else if(this.conversationsUnread){
			this.conversationsOpen = true;
		}
		else{
			this.conversations();
		}
	}

	closeNotifiche(){
		this.notificheOpen = false;
	}

	openNotifiche(){
		this.conversationsOpen = false;
		if(this.notificheOpen){
			this.notificheOpen = false;
		}
		else{
			this.notificheOpen = true;
		}
	}

	getLivelloUtente(){
		this.ruoloUtente = this.dataService.getUtentiService().getRuoloByComuneId(this.comuneId);
	    console.log("CMP|HEADER - getRuoloUtente ", this.ruoloUtente);
	    if(this.dataService.getUtentiService().getUser().nomeCompleto){
			this.userTooltip = this.dataService.getUtentiService().getUser().nomeCompleto + " - Accesso " + this.dataService.getCommon().capitalize(this.ruoloUtente);
		}else{
			this.userTooltip = this.dataService.getUtentiService().getUser().username + " - Accesso " + this.dataService.getCommon().capitalize(this.ruoloUtente);
		}
	}

	cambioComune(comune: any) {
		this.comuneId = comune.id;
		console.log("CMP|HEADER - cambioComune comuneId", this.comuneId);
		this.dataService.cambioComune(this.comuneId);
	}

	userProfile() {
		this.dataService.navigateByUrl('/profilo-utente');
	}

	goToConversation(notifica){
		if (notifica.comune_id != this.comuneId) {
			this.dataService.navigateByUrl('/conversazioni/'+notifica.item_id);
			this.dataService.cambioComune(notifica.comune_id);
		}
		this.dataService.navigateByUrl('/conversazioni/'+notifica.item_id);
	}

	conversations() {
		this.dataService.navigateByUrl('/conversazioni');
	}

	openNotification(notifica) {
		let tipoNotifica = notifica.tipo;
		switch (tipoNotifica) {
			case 'conversazioni':
				this.goToConversation(notifica);
				break;
		}
		this.markNotificationAsRead(notifica);
	}

	markNotificationAsRead(notifica) {
		console.log('mark as read', notifica)
		this.dataService.setNotificaRead(notifica)
	}

	notifications() {
		// notifications
	}

	getComuneNotifica(comuneId) {
		let comuneNome = '';
		for (let comune of this.comuni) {
			if (comune.id == comuneId) {
				comuneNome = comune.nome_lungo;
			}
		}
		return comuneNome;
	}

	backCommand(){
		console.log("backCommand");
	}

	toggleMenu(){
		this.menuState.emit('toggleMenu');
	}

	logout() {
		console.log('CMP|HEADER - LOGOUT USER');
		if (this.authService.aritUser) {
			this.jossoService.sendLogout();
		}else{
			this.authService.logout();
		}
	}

	ngDestroy(){
		this.comuniDisponibiliSync.unsubscribe();
		this.comuneSync.unsubscribe();
	}
}
